enum MutationKeyIdentifier {
    UPDATE_LIQUIDITY_CALCULATOR_CALCULATION = 'UPDATE_LIQUIDITY_CALCULATOR_CALCULATION',
    UPDATE_LIQUIDITY_SETTINGS = 'UPDATE_LIQUIDITY_SETTINGS',
}

/**
 * Stable mutation keys so a mutation's pending state can be observed anywhere via `useIsMutating` / `useMutationState`,
 * regardless of which component triggered it.
 */
export const mutationKeys = {
    updateLiquidityCalculatorCalculation: () => [MutationKeyIdentifier.UPDATE_LIQUIDITY_CALCULATOR_CALCULATION],
    updateLiquiditySettings: () => [MutationKeyIdentifier.UPDATE_LIQUIDITY_SETTINGS],
};
